import { useContext } from "react";
import { NewsCategoryPageContext } from "../contexts/newsCategoryPageContext";

export const useNewsCategoryPageContext = () =>
  useContext(NewsCategoryPageContext);
